<template>
  <v-app>
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="6" md="4" class="text-center">

            <div v-if="loading">
              <v-progress-circular indeterminate color="primary" size="64" />
              <p class="mt-4">กำลังยืนยันตัวตน กรุณารอสักครู่...</p>
            </div>

            <div v-else-if="errorMsg">
              <v-icon color="error" size="64">mdi-alert-circle</v-icon>
              <p class="mt-4 error--text">{{ errorMsg }}</p>
              <v-btn color="primary" class="mt-4" @click="goHome">กลับหน้าหลัก</v-btn>
            </div>

          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'PaotangCallbackView',
  data() {
    return {
      loading: true,
      errorMsg: '',
    };
  },
  async mounted() {
    const code = this.$route.query.code;
    const state = this.$route.query.state;
    const error = this.$route.query.error;

    if (error) {
      this.errorMsg = `Paotang ปฏิเสธการยืนยันตัวตน: ${this.$route.query.error_description || error}`;
      this.loading = false;
      return;
    }

    if (!code) {
      this.errorMsg = 'การยืนยนตัวตนไม่สำเร็จ กรุณาตรวจสอบ';
      this.loading = false;
      return;
    }

    try {
      // The cifno the user typed before redirecting to Paotang is verified
      // server-side by looking up `state` in tbl_login_paotang (see
      // Auth/funcPaotangAuthInit) — the backend rejects with
      // citizen_mismatch/state_invalid if it can't confirm the scanned
      // Paotang account matches, so this response can be trusted as-is
      // without re-checking anything client-side.
      const resp = await this.$store.dispatch('Auth/funcPaotangExchange', { code, state });
      console.log('[PaotangCallback] exchange+profile response:', resp);

      const cifno = resp.citizen_id;
      sessionStorage.setItem('paotang_auth_cifno', cifno);

      this.$store.commit('Auth/SET_USER_DATA', {
        paotangToken: resp.access_token,
        cifno: cifno,
        name: resp.name,
      });

      this.$router.replace({ path: '/', query: { paotang_auth: 'success' } });
    } catch (err) {
      console.error('[PaotangCallback] error:', err);
      const errCode = err.response && err.response.data && err.response.data.error;
      if (errCode === 'citizen_mismatch') {
        this.errorMsg = 'เลขบัตรประชาชนไม่ตรงกับบัญชีเป๋าตัง กรุณาใช้บัญชีเป๋าตังที่ผูกกับเลขบัตรประชาชนที่กรอก';
      } else if (errCode === 'state_invalid') {
        this.errorMsg = 'เซสชันหมดอายุ กรุณาเข้าสู่ระบบใหม่อีกครั้ง';
      } else {
        this.errorMsg = 'ไม่สามารถยืนยันตัวตนได้ กรุณาลองใหม่อีกครั้ง';
      }
      this.loading = false;
    }
  },
  methods: {
    goHome() {
      this.$router.replace({ path: '/' });
    },
  },
};
</script>
